import {useEffect, useState} from "react";
import SubscribeButton from "./subscribe-button/SubscribeButton";
import {SubscribeType} from "../types";
import {baseUrl, getDataFromKms} from "@mediaspace/shared/utils";
import NotificationMessage from "./notification-message/NotificationMessage"


export interface SubscribeProps extends SubscribeType {
    linksCount: number;
}

/**
 *  channel subscribe
 */
const Subscribe = (props: SubscribeProps) => {

    const {linksCount, subscribed, channelId, subscribeUrl, unsubscribeUrl} = props;

    const [isSubscribed, setIsSubscribed] = useState<boolean>(subscribed);
    const [showNotification, setShowNotification] = useState<boolean>(false);
    const [success, setSuccess] = useState<boolean>(true);
    const [processing, setProcessing] = useState<boolean>(false);

    const handleSuccess = (data) => {
        if (!data.success) {
            handleError();
            return;
        }
        setProcessing(false);
        setIsSubscribed(data.isSubscribed);
        setSuccess(true);
        setShowNotification(true);
    }

    const handleError = () => {
        setProcessing(false);
        setSuccess(false);
        setShowNotification(true);
    }

    const onToggle = () => {
        setProcessing(true);
        getDataFromKms(
            `${baseUrl}${isSubscribed ? unsubscribeUrl : subscribeUrl}`,
            {channelId},
            handleSuccess,
            false,
            handleError
        )
    }

    const handleClose = () => {
        setShowNotification(false);
    }

    useEffect(() => {
        const searchValue = subscribed ? 'subscribe' : 'unsubscribe';
        window.history.pushState(null,"",window.location.href.replace(`/${searchValue}`,''));
    }, []);

    const buttonColor = linksCount === 0 ? "primary" : "translucent";
    const useIconButton = linksCount > 1;

    return (
        <>
            <SubscribeButton
                subscribed={isSubscribed}
                onToggle={onToggle}
                processing={processing}
                buttonColor={buttonColor}
                useIconButton={useIconButton}
            />
            <NotificationMessage
                show={showNotification}
                onClose={handleClose}
                success={success}
                subscribed={isSubscribed}
            />
        </>
    )
};

export default Subscribe;
